import React, { useEffect } from "react";
import NavSection from "./Components/NavSection";
import FilterAttendanceBar from "./Components/FilterAttendanceBar";
import AttendanceTable from "./Components/AttendanceTable";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton, Empty } from "antd";
import { useTranslation } from "react-i18next";
import { fetchStaffsMonthAttendanceList } from "../../../Store/Slices/Admin/staffAttendance/staffAttendance.thunk";

const MainSection = () => {
  const { t } = useTranslation("admClass");
  const dispatch = useDispatch();
  const { cid } = useParams(); // Get class ID from URL

  const { loading, error, filters } = useSelector(
    (state) => state.admin.staffAttendance
  );

  useEffect(() => {
    if (filters.month) {
      const year = filters.year || new Date().getFullYear(); 

      dispatch(
        fetchStaffsMonthAttendanceList({
          month: filters.month,
          year,
        })
      );
    }
  }, [filters, dispatch]);

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <NavSection />
      <FilterAttendanceBar />
      {error ? (
        <Empty description={t("No attendance data found")} />
      ) : (
          <AttendanceTable />
      )}
    </div>
  );
};

export default MainSection;
